import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../../blocks/heigh-educate-banner";
import { HeighEducateChallenge } from "../../../blocks/customer-heigh-educate-challenge";
import { HeighEducateIdea } from "../../../blocks/customer-heigh-educate-idea";
import { useTranslation } from "react-i18next";
import { CustomerDetailIntro } from "../../../blocks/customer-detail-intro";
import { Footer } from "../../../components/FooterV2";
import { Helmet } from "react-helmet";
import { CommonPageLink } from "../../../blocks/common-page-link";

export const XianGongPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.xian-gong.challenge.item1.title"),
      description: t("customer.xian-gong.challenge.item1.description"),
    },
    {
      title: t("customer.xian-gong.challenge.item2.title"),
      description: t("customer.xian-gong.challenge.item2.description"),
    },
    {
      title: t("customer.xian-gong.challenge.item3.title"),
      description: t("customer.xian-gong.challenge.item3.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.xian-gong.ideas.item1.title"),
      descript: t("customer.xian-gong.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.xian-gong.ideas.item2.title"),
      descript: t("customer.xian-gong.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.xian-gong.ideas.item3.title"),
      descript: t("customer.xian-gong.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
  ];
  return (
    <div className="xiangong-page">
      <Helmet>
        <title>
          仙工智能SSO单点登录案例_仙工智能统一身份认证案例-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.xian-gong.banner.title")}
        subtitle={t("customer.xian-gong.banner.subtitle")}
        theme="#65A1F8"
        imgUrl={
          "//files.authing.co/authing-website/customer-story-detail-banner-seer.png"
        }
      />
      <CustomerDetailIntro
        imgUrl="//files.authing.co/authing-website/customer-story-detail-intro-seer.png"
        content={
          <>
            <p>{t("customer.xian-gong.intro.descript1")}</p>
            <p>{t("customer.xian-gong.intro.descript2")}</p>
          </>
        }
      />
      <HeighEducateChallenge
        challenges={challenges}
        theme="#65A1F8"
        // scale={{ 350: 1, 750: 2, 900: 2, 1200: 3 }}
        scale={{ 1200: 3 }}
      />
      <HeighEducateIdea
        ideas={ideas}
        theme="#65A1F8"
        // scale={{ 350: 1, 750: 2, 900: 2, 1200: 3 }}
        scale={{ 1200: 3 }}
      />
      <CommonPageLink pagesLink={pagesLink} theme="#65A1F8" />

      <Footer />
    </div>
  );
};
